/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Icon, Segment } from '@mairistem/composants';

import { Steps } from '@/enums';
import type { AssistantStep } from '@/types';
import { AssistantContext } from '@/contexts';

interface Props {
  /** Index de l'étape actuelle */
  currentStepIndex: number;
  /** En chargement */
  loading: boolean;
  /** Callback appelé lors du changement d'étape */
  onStepChange: (stepIndex: Steps) => void;
  /** Callback appelé lors du clique sur le bouton 'Terminer' */
  onFinish: () => void;
  /** Mode d'assitant */
  steps: Partial<Record<Steps, AssistantStep>>;
}

const AssistantFooter = (props: Props) => {
  // #region Declarations
  const { currentStepIndex, onStepChange, onFinish, loading, steps } = props;

  const { selectedDeclarationType, selectedPacs } =
    React.useContext(AssistantContext);

  const stepKeys = Object.keys(steps).map(Number) as Steps[];
  const currentKeyIndex = stepKeys.indexOf(currentStepIndex);
  const prevStep = currentKeyIndex > 0 ? stepKeys[currentKeyIndex - 1] : null;
  const nextStep =
    currentKeyIndex < stepKeys.length - 1
      ? stepKeys[currentKeyIndex + 1]
      : null;

  // Désactive le bouton "Étape suivante" si pas de type sélectionné / pas de PACS sélectionné
  const isNextStepDisabled =
    loading ||
    (currentStepIndex === Steps.TypeDeclaration && !selectedDeclarationType) ||
    (currentStepIndex === Steps.SelectionPACS && !selectedPacs);
  // #endregion

  // #region Component

  return (
    <Segment
      style={{
        display: 'flex',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        background: 'transparent',
        boxShadow: 'none',
      }}
    >
      {prevStep !== null && (
        <Button
          data-testid="assistant-etape-precedente"
          onClick={() => onStepChange(prevStep)}
          disabled={loading}
          loading={loading}
        >
          <Icon name="angle left" />
          Étape précédente
        </Button>
      )}
      <div style={{ flex: 1 }} />
      {nextStep === null ? (
        <Button
          positive
          data-testid="assistant-terminer"
          onClick={onFinish}
          disabled={loading}
          loading={loading}
        >
          <Icon name="flag checkered" />
          Terminer
        </Button>
      ) : (
        <Button
          data-testid="assistant-etape-suivante"
          onClick={() => onStepChange(nextStep)}
          disabled={isNextStepDisabled}
          loading={loading}
        >
          Étape suivante
          <Icon name="angle right" />
        </Button>
      )}
    </Segment>
  );
};

export default AssistantFooter;
